export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_09.b21bab6c.jpg";